import { Segment, Popup, Icon } from 'semantic-ui-react';
import styled from 'styled-components';
import FlexBoxTmp from './FlexBox';

const FlexBox = styled(FlexBoxTmp)`
	justify-content: space-evenly;
	text-align: center;
`;

const Header = styled.h5`
	padding: 0;
	margin: 0 0 5px 0;
`;

const Saving = styled.div`
	text-align: center;
`;

const Span = styled.span`
	margin-left: 5px !important;
`;

function DetailsSegment({ details, color, loading }) {
	return (
		<Segment raised color={color}>
			{loading ? (
				<Saving>Loading...</Saving>
			) : (
				<FlexBox>
					{details.filter(detail => detail.title).map((detail, i) => {
						return (
							<div key={i}>
								<Header>{detail.header}</Header>
								{!detail.handler &&	<span>{detail.title}</span>}
								{detail.info && <Span><Popup content={detail.info} trigger={<Icon name="info circle" color="teal" />} /></Span>}
								{detail.handler && <p onClick={() => detail.handler(detail.params)}>{detail.title}</p>}
							</div>
						)
					})}
				</FlexBox>
			)}
		</Segment>
	);
}

export default DetailsSegment;
